<template>
  <div></div>
</template>

<script>
import { authenticateAndNavigateConstant, authenticateAndNavigateMethods } from "./authenticateAndNavigate.constant";
import { storeAction } from "../../store/storeActions.constant";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { routerNames } from "../appCommon.constants";
import { storeMutation } from "../../store/storeMutations.constant";
import { storeGetters } from "../../store/storeGetters.constant";
import { ypoConciergeConstant } from "../YpoConcierge/ypoConcierge.constant";

export default {
  name: "AuthenticateAndNavigate",
  components: {},
  data() {
    return {
      forwardedFromRoute: "",
    };
  },
  created() {
    this.forwardedFromRoute = this.$route.params && this.$route.params.forwardFrom;
    if (this.forwardedFromRoute) {
      const navigationData = authenticateAndNavigateConstant.navigateOptions
          .find(option => option.routeName === this.forwardedFromRoute);
      if (navigationData && navigationData.preCheckMethod) {
        this[navigationData.preCheckMethod]();
      } else {
        this.goHome();
      }
    } else {
      this.goHome();
    }
  },
  methods: {
    ...mapActions({
      registerInAdobe: `auth/${storeAction.registerInAdobe}`,
      getProfileInformation: `myAccount/${storeAction.getProfileInformation}`,
    }),
    ...mapMutations({
      ypoError: `ypoError/${storeMutation.setYpoErrorData}`,
    }),
    goHome() {
      this.$router.push("/home");
    },
    async [authenticateAndNavigateMethods.conciergeCallback]() {
      let hasAccessToConciergePage = false;
      const userData = await this.getProfileInformation(this.currentUserId);
      if (userData) {
        const { recordTypeName } = userData.data;
        if (recordTypeName && ypoConciergeConstant.rolesWithAccessToConcierge.includes(recordTypeName)) {
          hasAccessToConciergePage = true;
        }
      }
      if (hasAccessToConciergePage) {
        window.location.href = authenticateAndNavigateConstant.navigationUrls.concierge;
      } else {
        this.ypoError(2);
        this.$router.push({
          path: `/${routerNames.ERROR_PAGE}`,
        });
      }
    },
    [authenticateAndNavigateMethods.lmsCallback]() {
      this.registerInAdobe()
          .then((response) => {
            if (response && response.data) {
              window.location.href = authenticateAndNavigateConstant.navigationUrls.lms;
            } else {
              this.ypoError(1);
              this.$router.push({
                path: `/${routerNames.ERROR_PAGE}`,
              });
            }
          });
    },
    async [authenticateAndNavigateMethods.chapterManagementCallback]() {
      let hasAccessToChapterManagementSuit = false;
      const userData = await this.getProfileInformation(this.currentUserId);
      if (userData && userData.data && userData.data.salesforceAccessfromExchange) {
          hasAccessToChapterManagementSuit = true;
      }
      if (hasAccessToChapterManagementSuit) {
        window.location.href = authenticateAndNavigateConstant.navigationUrls.chapterManagement;
      } else {
        this.ypoError(2);
        this.$router.push({
          path: `/${routerNames.ERROR_PAGE}`,
        });
      }
    },
    async [authenticateAndNavigateMethods.m2mxProfileCallback]() {
      let hasAccessToM2mxProfile = false;
      const userData = await this.getProfileInformation(this.currentUserId);
      if (userData) {
        const { recordTypeName } = userData.data;
        if (recordTypeName && authenticateAndNavigateConstant.rolesWithAccessToM2mxProfile.includes(recordTypeName)) {
          hasAccessToM2mxProfile = true;
        }
      }
      if (hasAccessToM2mxProfile) {
        window.location.href = authenticateAndNavigateConstant.navigationUrls.m2mxProfile;
      } else {
        this.ypoError(2);
        this.$router.push({
          path: `/${routerNames.ERROR_PAGE}`,
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      currentUserId: `auth/${storeGetters.currentUserId}`,
    }),
  },
};
</script>
<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
</style>
